import React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import './Login.css'
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

import { loginDriver } from "../../redux/DriverReducer";

import { loginCustomer } from "../../redux/CustomerReducer";
const DriverLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [user, setUser] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({
      ...user,
      [name]: value,
    });
  };

  const loginClicked = async () => {
    console.log("Clicked");

    const response = await dispatch(loginDriver(user));

    if (response.payload.status) {
      Swal.fire("Good", response?.payload?.message, "success");

      navigate("/driver/dashboard");
    }
  };

  return (
    <>
      <div className="mainContainerLogin">
        <div className="userLoginTxt">Driver Login</div>

        <div className="topInputFieldLogin">
          <div className="inputTxtLogin">Email</div>
          <input
            className="inputLogins"
            type="email"
            onChange={handleChange}
            name="email"
            placeholder="Enter Email"
          />
        </div>
        <div className="topInputFieldLogin">
          <div className="inputTxtLogin">Password</div>
          <input
            className="inputLogins"
            onChange={handleChange}
            name="password"
            type="password"
            placeholder="Enter Password"
          />
        </div>
        <div className="forgotPassTxt">Forgot password?</div>

        <button className="loginBtn" onClick={() => loginClicked()}>
          Login
        </button>
      </div>
    </>
  );
};

export default DriverLogin;
